import { useQuery } from '@tanstack/react-query';
import { usePublishedContext } from '@/components/views/published/PublishedContext';
import { getCurrentUserProfile } from '@/lib/api/profile/profileApi';
import { userManagementQueryKeys } from '@/lib/query-keys/userManagement';

export const useUserProfileQueryWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const publishedContext = usePublishedContext();
  return useQuery({
    queryKey: userManagementQueryKeys.profile(),
    queryFn: () => getCurrentUserProfile(),
    staleTime: Infinity,
    enabled: publishedContext !== null ? false : enabled,
  });
};
